import { useContext } from 'react';

import * as T from 'prop-types';

import { Flex } from '@olist/united';

import { AlertContext } from '../../contexts/alert-context';

import AlertNotification from '.';

const GlobalAlert = ({ children }) => {
  const { alert } = useContext(AlertContext);
  return (
    <>
      {children}
      {alert?.show && (
        <AlertNotification variation={alert?.variation ?? 'danger'}>
          <Flex flexDirection="row" width="100%">
            <AlertNotification.Icon iconName={alert?.iconName} />
            <AlertNotification.Information title={alert?.title} text={alert?.text} />
          </Flex>
        </AlertNotification>
      )}
    </>
  );
};

GlobalAlert.propTypes = {
  children: T.node.isRequired,
};

export default GlobalAlert;
